// extracted by mini-css-extract-plugin
export default {"tupacGrid":"pl-z","tupacHeader":"ql-z","tupacHeader2":"rl-z","tupacMenu":"sl-z","tupacMenu2":"tl-z","tupacMain":"ul-z","tupacMain2":"vl-z"};